/* global pca */
import { _ } from '../utils.js'
import pcaConfig from '../config/pca-lookup.js'

export default class PcaLookup {
    constructor(el) {
        this.el = el
        this.countrySelect = _('country', 'element').nodeFrom(this.el)
        this.options = {
            key: 'JC65-GB21-RU89-CY75',
            search: {
                countries: this.countrySelect.value || '',
            },
            setCountryByIP: true,
            GeoLocationEnabled: true,
        }
        this.control = ''
        if (typeof pca !== 'undefined') {
            this.fields = pcaConfig.fields.reduce((fields, field) => {
                fields.push({
                    element: _(field.name, 'element').nodeFrom(this.el),
                    mode: field.mode(pca),
                    ...field,
                })
                return fields
            }, [])
            this.control = new pca.Address(this.fields, this.options)

            this.control.listen('load', () => {
                this.countrySelect.addEventListener('change', this.setCountry)
            })
        } else {
            console.warn('pca undefined')
        }
    }
    setCountry = () => {
        this.control.destroy()
        this.options.search.countries = this.countrySelect.value || 'GB'
        this.control = new pca.Address(this.fields, this.options)
    }
}
